<template>
  <div>
    <Header
      title="调课审核"
      type="0"
      :route="
        this.back
          ? this.back + '?path=/pass/index'
          : '/teacher/examine/adjustList'
      "
      :casLogin="casLogin"
    ></Header>
    <div class="center">
      <div class="center-list">
        <div class="paperClip-circle"></div>
        <img class="paperClip" src="../../../../assets/images/paperClip.png" />
        <div class="list-left">
          <div class="left-title">{{ route_tk.kcmc }}</div>
          <div class="left-line" v-if="schoolCode == '10320'">
            <div style="width:100%">
              <span>学年学期:</span>
              <span style="margin-left: 5px;">{{ xnxq }}</span>
            </div>
          </div>
          <div class="left-line">
            <div style="width:40%">
              <span>教师:</span>
              <span style="margin-left: 5px;">{{ oldjsmc }}</span>
            </div>
            <div class="left-line-line">
              <span>调课方式:</span>
              <span style="margin-left: 5px;">{{ route_tk.tkfs }}</span>
            </div>
          </div>
          <div class="left-line">
            <div style="width:40%">
              <span>院系:</span>
              <span style="margin-left: 5px;">{{ info.dwmc }}</span>
            </div>
            <div class="left-line-line">
              <span>调课类型:</span>
              <span style="margin-left: 5px;">{{ route_tk.tklx }}</span>
            </div>
          </div>
          <div class="left-line">
            <div style="width:100%">
              <span>班级:</span>
              <span style="margin-left: 5px;">{{ route_tk.ktmc }}</span>
            </div>
          </div>
          <div class="left-line" v-if="schoolCode == '10320'">
            <div style="width:40%">
              <span>申请人:</span>
              <span style="margin-left: 5px;">{{ sqr }}</span>
            </div>
            <div style="width:40%">
              <span>开课单位:</span>
              <span style="margin-left: 5px;">{{ kkdw }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="center-content-white">
        <div class="white-left">时间模式</div>
        <div class="white-right">{{ info.oldkbjcmsid }}</div>
      </div>
      <div class="center-content-white">
        <div class="white-left">上课周次</div>
        <div class="white-right">{{ info.ykkzc }}</div>
      </div>
      <div class="center-content-gray">
        <div class="gray-line-one">
          <div class="gray-left">新上课周次</div>
          <div class="gray-right">{{ info.xkkzc }}</div>
        </div>
        <div class="gray-line-one">
          <div class="gray-left">待调整周次</div>
          <div class="gray-right" style="color:#757DA3;">{{ info.kkzc }}</div>
        </div>
      </div>

      <div class="center-content-gray">
        <div class="gray-line-one">
          <div class="gray-left">时间</div>
          <div class="gray-right">{{ info.kcsj }}</div>
        </div>
        <div class="gray-line-one">
          <div class="gray-left" style="text-decoration: line-through;">
            原时间
          </div>
          <div
            class="gray-right"
            style="color:#757DA3;text-decoration: line-through;"
          >
            {{ info.ykcsj }}
          </div>
        </div>
      </div>

      <div class="center-content-gray" v-if="route_tk.tklx == '变更教师'">
        <div class="gray-line-one">
          <div class="gray-left">教师</div>
          <div class="gray-right">{{ jsmc }}</div>
        </div>
        <div class="gray-line-one">
          <div class="gray-left" style="text-decoration: line-through;">
            原教师
          </div>
          <div
            class="gray-right"
            style="color:#757DA3;text-decoration: line-through;"
          >
            {{ route_tk.skls }}
          </div>
        </div>
      </div>

      <div class="center-content-gray">
        <div class="gray-line-one">
          <div class="gray-left">地点</div>
          <div class="gray-right">{{ info.xjsmc }}</div>
        </div>
        <div class="gray-line-one" v-if="schoolCode == '10320'">
          <div class="gray-left">地点功能区</div>
          <div class="gray-right">{{ gnq }}</div>
        </div>
        <div class="gray-line-one">
          <div class="gray-left" style="text-decoration: line-through;">
            原地点
          </div>
          <div
            class="gray-right"
            style="color:#757DA3;text-decoration: line-through;"
          >
            {{ info.yjsmc }}
          </div>
        </div>
        <div class="gray-line-one" v-if="schoolCode == '10320'">
          <div class="gray-left" style="text-decoration: line-through;">
            原地点功能区
          </div>
          <div
            class="gray-right"
            style="color:#757DA3;text-decoration: line-through;"
          >
            {{ yddgnqmc }}
          </div>
        </div>
      </div>

      <div class="center-content-white">
        <div class="white-left">单双周</div>
        <div class="white-right">{{ route_tk.dsz }}</div>
      </div>

      <div class="center-content-white" v-if="schoolCode == '10320'">
        <div class="white-left">调课分类</div>
        <div class="white-right">{{ tkfl }}</div>
      </div>

      <div class="center-content-white" style="align-items: flex-start;">
        <div class="white-left">调课原因</div>
        <div
          class="white-right"
          style="width: 60%;word-break: break-all;text-align: right"
        >
          {{ info.tkyy }}
        </div>
      </div>
      <div class="center-content-white" style="align-items: flex-start;">
        <div class="white-left">附件</div>
        <div
          :class="{'white-right':true, mult: schoolCode === '13575'}"
          style="width: 60%;word-break: break-all;text-align: right"
        >
          <template v-if="schoolCode === '13575'">
            <div id="myMain">
              <div v-for="(item,index) in fjlist" :key="index" >
                <div v-if="item.filename">{{ item.filename }}</div>
                <img v-else :src="item.src" alt="" @click="reImage(item.src)">
              </div>
            </div>
          </template>
          <div v-else-if="schoolCode === '13720'" style="color: blue;" @click="CheckFile(filemap.fileName,filemap.filePath)">{{ filemap.fileName }}</div>
          <div v-else id="myMain" @click="reImage"></div>
        </div>
      </div>
      <!-- <van-field
            name="uploader"
            input-align="right"
            class="upload-line"
            label="附件"
            v-if="!route_tk.new"
          >
            <template #input>
              <div id="myMain" @click="reImage"></div>
            </template>
          </van-field> -->
    </div>
    <van-popup v-model="show" id="reImg"></van-popup>
    <div class="bottom">
      <van-button class="bottom-button" type="default" @click="pushExamine"
        >审核</van-button
      >
    </div>
  </div>
</template>
<script>
import { Api } from "@/utils/axios";
export default {
  data() {
    return {
      casLogin: sessionStorage.getItem("casLogin"),
      schoolCode: sessionStorage.getItem("schoolCode"),
      list: [],
      route_tk: {},
      info: {},
      jsmc: "",
      oldjsmc: "",
      img: {},
      img1: {},
      show: false,
      back: "",
      xnxq: "",
      sqr: "",
      kkdw: "",
      gnq: "",
      tkfl: "",
      yddgnqmc: "",
      fjisyl: true,
      fjlist:[],
      filemap:{},
      fileYlData:{}
    };
  },
  mounted() {
    this.getList();
    this.back = JSON.parse(
      decodeURIComponent(this.$route.params.route_params)
    ).route;
  },
  methods: {
    async getMFile() {
      const ret = await Api.downfile_13575({
        tkid: this.route_tk.ywinstanceid
      });
      this.fjlist = ret.data
        .filter(item => item)
        .map(item => {
          if (item.length > 1000) {
            return {
              src: item
            };
          } else {
            return {
              filename: item
            };
          }
        });
    },
    reImage(src) {
      if(src){
        this.show = true;
        this.$nextTick(() => {
          let img = document.createElement("img");
          img.style.width = "320px";
          img.src = src
          document.getElementById("reImg").appendChild(img);
        });
      }else{
        if (this.fjisyl) {
          this.show = true;
          this.$nextTick(() => {
            if (this.img.width >= 320) {
              this.img.style.width = "320px";
            } else {
              this.img.style.width = "auto";
            }
            document.getElementById("reImg").appendChild(this.img);
          });
        }
      }
    },
    async getList() {
      var casparamId = this.$route.query.casparamId;
      if(casparamId != null && casparamId != ''){
        const param = {
          casparamId: casparamId
        }
        const res = await Api.getTklist(param);
        var data = res.data[0]
        data.ywcode = "009";
        data.route = '/pass/index';
        this.route_tk =data
      }else{
        this.route_tk = JSON.parse(decodeURI(this.$route.params.route_params));
      }
      let ret = null;
      if (this.route_tk.ywcode == "009") {
        ret = await Api.downfile_tk({
          tkid: this.route_tk.ywinstanceid
        });
      } else if (this.schoolCode === "13575") {
        this.getMFile();
      } else {
        ret = await Api.downfile({
          tkid: this.route_tk.ywinstanceid
        });
      }
      let params = {
        tkid: this.route_tk.ywinstanceid
      };
      if (!!this.route_tk.sfsyk && this.schoolCode == "11534") {
        params.sfsyk = this.route_tk.sfsyk;
      }
      if (!!this.route_tk.ywcode && this.route_tk.ywcode == "095") {
        params.sfsyk = "1";
      }
      const res = await Api.getTkck(params);
      this.info = res.jx0408ttkList[0];
      this.jsmc = res.changeJgnew;
      this.oldjsmc = res.changeJgold;
      if (this.schoolCode == "10320") {
        this.xnxq = this.info.xnxq01id;
        this.sqr = this.info.sqr;
        this.kkdw = this.info.kkdw;
        this.gnq = this.info.gnqmc;
        this.tkfl = this.info.tkyylx;
        this.yddgnqmc = this.info.yjsgncmc;
      }
      if (this.schoolCode == "13720") {
        this.filemap = res.filemap;
      }
      if (this.route_tk.cjr.includes("[")) {
        this.route_tk.cjr = this.route_tk.cjr.split("[")[0];
      }
      if (ret.code != 0 && this.schoolCode !== "13575" && this.schoolCode !== "13720") {
        if (ret.type == "application/json") {
          let span = document.createElement("span");
          span.innerText = "无";
          document.getElementById("myMain").appendChild(span);
          return;
        }
        if (ret.type == "image/jpeg" || ret.type == "image/png") {
          let blob = new Blob([ret], {
            type: ["image/png", "image/jpeg", "image/gif"]
          });
          this.img = document.createElement("img");
          this.img1 = document.createElement("img");
          let url = window.URL.createObjectURL(blob);
          this.img.src = url;
          this.img.onload = function() {
            window.URL.revokeObjectURL(url);
          };

          this.img1.src = url;
          this.img1.onload = function() {
            window.URL.revokeObjectURL(url);
          };
          this.img1.style.width = "80px";
          this.img1.style.height = "80px";
          document.getElementById("myMain").appendChild(this.img1);
        } else {
          this.fjisyl = false;
          let span = document.createElement("span");
          span.innerText = "无法预览该格式附件";
          document.getElementById("myMain").appendChild(span);
          return;
        }
      }
    },
    CheckFile(fileName,filePath){
      if(fileName==''&&filePath==''){
          return;
        }
        this.fileYlData.fileurl = filePath;
        this.fileYlData.qzwffilename = fileName;
        localStorage.setItem("shyjData", JSON.stringify(this.fileYlData));
        this.$router.push({
          path: "/teacher/filePreview",
          query: { 
             route:'/teacher/bookIndex?id=8',
             //list:this.$route.query.list
          },
        });
    },
    pushExamine() {
      this.route_tk.id_sh = this.route_tk.id;
      this.route_tk.xq_id = this.route_tk.ywinstanceid;
      this.route_tk.sh_flag = "009";
      this.$router.push({
        name: "examineCommom",
        params: {
          route: "adjustListDetail,1",
          route_params: encodeURI(JSON.stringify(this.route_tk))
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.bottom {
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 0 20px;
  background-color: #fff;

  .bottom-button {
    width: calc(~"100% - 40px");
    background-color: @attendance-background-color-1;
    color: white;
    font-size: 16px;
    font-weight: 600;
    height: 44px;
    line-height: 44px;
    border-radius: 3px;
    margin-bottom: 10px;
  }
}
.upload-line {
  /deep/ .van-field__label {
    width: 75px;
  }
}
.center {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding-bottom: 40px;
  .center-list {
    width: calc(~"100% - 80px");
    background: url(../../../../assets/images/card_bg3.png) no-repeat top center;
    background-size: cover;
    border-radius: 5px;
    margin-top: 20px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    padding: 20px 20px 18px 20px;
    position: relative;
    .paperClip {
      position: absolute;
      right: 20px;
      top: 20px;
      width: 22px;
      height: 22px;
    }
    .paperClip-circle {
      position: absolute;
      right: 15px;
      top: 15px;
      width: 32px;
      height: 32px;
      border-radius: 30px;
      background: @attendance-background-color-16;
    }
    .list-left {
      width: 100%;
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      .left-title {
        width: 100%;
        font-size: 16px;
        color: white;
        font-weight: 600;
        letter-spacing: 1px;
        margin-bottom: 8px;
      }
      .left-line {
        width: 100%;
        font-size: 12px;
        color: rgb(243, 240, 240);
        margin-bottom: 2px;
        display: flex;
      }
    }
  }
  .center-content-white {
    flex-wrap: wrap;
    width: calc(~"100% - 60px");
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .white-left {
      color: @attendance-color-2;
      font-size: 14px;
    }
    .white-right {
      color: @attendance-color-2;
      font-size: 14px;
      font-weight: 600;
    }
  }
  .center-content-gray {
    width: calc(~"100% - 60px");
    margin-bottom: 16px;
    padding: 8px 10px 4px 10px;
    display: flex;
    flex-wrap: wrap;
    background-color: @attendance-background-color-10;
    border-radius: 3px;
    .gray-line-one {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 4px;
      .gray-left {
        color: @attendance-color-2;
        font-size: 14px;
      }
      .gray-right {
        color: @attendance-background-color-12;
        font-size: 14px;
        font-weight: 600;
      }
    }
  }
  .mult {
    width: 100% !important; 
    #myMain{
      display: flex;
      flex-wrap: wrap;
      width: 100%;

      & > div {
        width: 100%;
        display: flex;
        align-items: center;
        height: 60px;
        &+div{
          border-top: 1px solid #e5e5e5;
        }
      }

      img{
        margin: 5px;
        width: 34px;
        height: 34px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/Examine/class-adjustment/listDetail.vue